// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.header {
  flex: 0 0 80px;
  background-color: black;
  color: green;
  font-family: "Lexend", monospace;
  font-size: 20px;
  padding-left: 20px;
  position: sticky;
  top: 0;
}

.footer {
  flex-shrink: 0;
  flex: 0 0 auto;
  background-color: black;
  color: green;
  font-family: "Lexend", monospace;
  font-size: 20px;
  padding-left: 20px;
  position: sticky;
  margin-bottom: 10px;
  bottom: 0;
}

.sliding-logo {
  text-decoration: none;
  font-family: "Courier New", monospace;
  font-size: 48px;
  color: #00ff00;
  position: absolute;
  top: 0;
  animation: slide 1s linear 1 forwards;
}

.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content {
  flex: 1 1 auto;
  overflow-y: auto;
  max-width: 1200px;
  background-color: black;
  color: green;
  font-family: "Courier New", monospace;
  font-size: 20px;
  margin-top: 10px;
  overflow-x: hidden;
}

.content::-webkit-scrollbar {
  display: none;
}

.footer-item {
  cursor: pointer;
}

.footer-dark-hover .footer-item:hover {
  color: white;
}

.footer-light-hover .footer-item:hover {
  color: green;
}

@keyframes slide {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(50%);
  }
}

.scrollable-history {
  scrollbar-width: none;
}

.scrollable-history::-webkit-scrollbar {
  display: none;
}

.nested-container {
  overflow: hidden;
}

.input-wrapper {
  position: relative;
  width: 100%;
}

.input-wrapper span {
  position: relative;
  display: inline-block;
}

.input-wrapper span::before {
  content: "";
  position: absolute;
  bottom: 4px;
  left: 0px;
  width: 10px;
  height: 15px;
  background-color: green;
}

@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

.custom-input {
  caret-color: transparent !important;
  background-color: black;
  color: green;
  border: none;
  outline: none;
  font-size: 20px;
  font-family: "Courier New", monospace;
  width: 100%;
}

.caret {
  content: "";
  position: absolute;
  bottom: 4px;
  width: 10px;
  height: 15px;
  background-color: green;
  animation: blink-animation 1s steps(2, start) infinite;
  margin-left: 20px;
}

.input-container {
  position: relative;
  display: inline-block;
}

.styled-input {
  background-color: black;
  color: green;
  display: inline-block;
  font-family: "Courier New", monospace;
  font-size: 20px;
}

.actual-input {
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
  color: green;
  caret-color: green;
  font-family: "Courier New", monospace;
  font-size: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.hide-element {
  visibility: hidden !important;
}

.bright-response,
.bright-logo {
  color: #00ff00;
}

.sliding-logo-light {
  text-decoration: none;
  font-family: "Courier New", monospace;
  font-size: 48px;
  color: white;
  position: absolute;
  top: 0;
  animation: slide 1s linear 1 forwards;
}

.bright-response {
  color: var(--bright-response-color);
}

:root {
  --bright-response-color: #00ff00;
}

body.light-mode {
  --bright-response-color: #ffffff;
}

.clickable {
  cursor: pointer;
}

.bright-response.bold {
  font-weight: bold;
}
.bold {
  font-weight: bold;
}

.white-bold {
  color: white;
  font-weight: bold;
}

.custom-link {
  text-decoration: none;
  outline: none;
  color: inherit;
}

.custom-link:visited {
  color: inherit;
}

.custom-link:active {
  color: inherit;
}

.custom-link:focus {
  outline: none;
}

.bright-response {
  color: var(--bright-response-color);
}
.popup {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: white;
  padding: 10px;
  border-radius: 5px;
  z-index: 1000;
}

.list-content {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: black;
  color: green;
  font-family: "Courier New", monospace;
  font-size: 20px;
}

.list-content.light-mode {
  background-color: blue;
  color: white;
}

.scrollable-content {
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 20px;
}

.scrollable-list-content {
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 20px;
}

.scrollable-list-content::-webkit-scrollbar {
  display: none;
}

.project-details {
  margin-top: 10px;
  padding-right: 10px;
  box-sizing: border-box;
}

h2 {
  cursor: pointer;
}

.project-title-dark {
  cursor: pointer;
  color: green;
}

.project-title-dark:hover {
  color: white;
}

.project-title-light {
  cursor: pointer;
  color: white;
}

.project-title-light:hover {
  color: green;
}

.divider-dark {
  height: 1px;
  background-color: green;
  margin: 10px 0;
}

.divider-light {
  height: 1px;
  background-color: white;
  margin: 10px 0;
}

.youtube-link-dark {
  text-decoration: none;
  color: green;
}

.youtube-link-dark:hover {
  color: white;
}

.youtube-link-light {
  text-decoration: none;
  color: white;
}

.youtube-link-light:hover {
  color: green;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/Css/Common.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,sDAAsD;EACtD,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":["html,\nbody {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.header {\n  flex: 0 0 80px;\n  background-color: black;\n  color: green;\n  font-family: \"Lexend\", monospace;\n  font-size: 20px;\n  padding-left: 20px;\n  position: sticky;\n  top: 0;\n}\n\n.footer {\n  flex-shrink: 0;\n  flex: 0 0 auto;\n  background-color: black;\n  color: green;\n  font-family: \"Lexend\", monospace;\n  font-size: 20px;\n  padding-left: 20px;\n  position: sticky;\n  margin-bottom: 10px;\n  bottom: 0;\n}\n\n.sliding-logo {\n  text-decoration: none;\n  font-family: \"Courier New\", monospace;\n  font-size: 48px;\n  color: #00ff00;\n  position: absolute;\n  top: 0;\n  animation: slide 1s linear 1 forwards;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.content {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  max-width: 1200px;\n  background-color: black;\n  color: green;\n  font-family: \"Courier New\", monospace;\n  font-size: 20px;\n  margin-top: 10px;\n  overflow-x: hidden;\n}\n\n.content::-webkit-scrollbar {\n  display: none;\n}\n\n.footer-item {\n  cursor: pointer;\n}\n\n.footer-dark-hover .footer-item:hover {\n  color: white;\n}\n\n.footer-light-hover .footer-item:hover {\n  color: green;\n}\n\n@keyframes slide {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(50%);\n  }\n}\n\n.scrollable-history {\n  scrollbar-width: none;\n}\n\n.scrollable-history::-webkit-scrollbar {\n  display: none;\n}\n\n.nested-container {\n  overflow: hidden;\n}\n\n.input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.input-wrapper span {\n  position: relative;\n  display: inline-block;\n}\n\n.input-wrapper span::before {\n  content: \"\";\n  position: absolute;\n  bottom: 4px;\n  left: 0px;\n  width: 10px;\n  height: 15px;\n  background-color: green;\n}\n\n@keyframes blink-animation {\n  to {\n    visibility: hidden;\n  }\n}\n\n.custom-input {\n  caret-color: transparent !important;\n  background-color: black;\n  color: green;\n  border: none;\n  outline: none;\n  font-size: 20px;\n  font-family: \"Courier New\", monospace;\n  width: 100%;\n}\n\n.caret {\n  content: \"\";\n  position: absolute;\n  bottom: 4px;\n  width: 10px;\n  height: 15px;\n  background-color: green;\n  animation: blink-animation 1s steps(2, start) infinite;\n  margin-left: 20px;\n}\n\n.input-container {\n  position: relative;\n  display: inline-block;\n}\n\n.styled-input {\n  background-color: black;\n  color: green;\n  display: inline-block;\n  font-family: \"Courier New\", monospace;\n  font-size: 20px;\n}\n\n.actual-input {\n  background-color: transparent;\n  border: none;\n  outline: none;\n  width: 100%;\n  color: green;\n  caret-color: green;\n  font-family: \"Courier New\", monospace;\n  font-size: 20px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.hide-element {\n  visibility: hidden !important;\n}\n\n.bright-response,\n.bright-logo {\n  color: #00ff00;\n}\n\n.sliding-logo-light {\n  text-decoration: none;\n  font-family: \"Courier New\", monospace;\n  font-size: 48px;\n  color: white;\n  position: absolute;\n  top: 0;\n  animation: slide 1s linear 1 forwards;\n}\n\n.bright-response {\n  color: var(--bright-response-color);\n}\n\n:root {\n  --bright-response-color: #00ff00;\n}\n\nbody.light-mode {\n  --bright-response-color: #ffffff;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.bright-response.bold {\n  font-weight: bold;\n}\n.bold {\n  font-weight: bold;\n}\n\n.white-bold {\n  color: white;\n  font-weight: bold;\n}\n\n.custom-link {\n  text-decoration: none;\n  outline: none;\n  color: inherit;\n}\n\n.custom-link:visited {\n  color: inherit;\n}\n\n.custom-link:active {\n  color: inherit;\n}\n\n.custom-link:focus {\n  outline: none;\n}\n\n.bright-response {\n  color: var(--bright-response-color);\n}\n.popup {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #333;\n  color: white;\n  padding: 10px;\n  border-radius: 5px;\n  z-index: 1000;\n}\n\n.list-content {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background-color: black;\n  color: green;\n  font-family: \"Courier New\", monospace;\n  font-size: 20px;\n}\n\n.list-content.light-mode {\n  background-color: blue;\n  color: white;\n}\n\n.scrollable-content {\n  flex-grow: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-left: 20px;\n}\n\n.scrollable-list-content {\n  flex-grow: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-left: 20px;\n}\n\n.scrollable-list-content::-webkit-scrollbar {\n  display: none;\n}\n\n.project-details {\n  margin-top: 10px;\n  padding-right: 10px;\n  box-sizing: border-box;\n}\n\nh2 {\n  cursor: pointer;\n}\n\n.project-title-dark {\n  cursor: pointer;\n  color: green;\n}\n\n.project-title-dark:hover {\n  color: white;\n}\n\n.project-title-light {\n  cursor: pointer;\n  color: white;\n}\n\n.project-title-light:hover {\n  color: green;\n}\n\n.divider-dark {\n  height: 1px;\n  background-color: green;\n  margin: 10px 0;\n}\n\n.divider-light {\n  height: 1px;\n  background-color: white;\n  margin: 10px 0;\n}\n\n.youtube-link-dark {\n  text-decoration: none;\n  color: green;\n}\n\n.youtube-link-dark:hover {\n  color: white;\n}\n\n.youtube-link-light {\n  text-decoration: none;\n  color: white;\n}\n\n.youtube-link-light:hover {\n  color: green;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
